export default "__VITE_PUBLIC_ASSET__1e80529d__"